import React, {useEffect, useState} from 'react';
import {Button, Form, Input, Label, Modal, ModalBody, ModalHeader} from 'reactstrap';
import RealGrid from '../CpmRealgrid/CpmRealgrid';
import {Field, FormikProvider, useFormik} from 'formik';
import * as Yup from "yup";
import {rg2Comm} from 'script/cpmRealgrid2.common';
import useDidMountEffect from 'script/useDidMountEffect';
import { useExtSubmission } from 'api';

const checkboxList = [
    [
        {label: '전체', value: 'chkAll', disabled: ['chkAf']},
        {label: '추후지정', value: 'chkAf'},
    ], [
        {label: '공동광고주 포함', value: 'uniInclude', disabled: ['chkAf']},
        {label: '청약 광고주만 조회', value: 'amtExist', disabled: ['chkAf']},
        {label: '대행만료 포함', value: 'pastChk', disabled: ['chkAf']},
        {label: '거래불가 포함', value: 'noDealYn', disabled: ['chkAf']},
    ]
]

// realgrid 컬럼
const columns = [
    {
        "width": 60,
        "name": "cliId",
        "header": {
            "text": "광고주코드"
        }
    },
    {
        "width": 120,
        "name": "cliNm",
        "styleName": "rg-left-align",
        "header": {
            "text": "광고주명"
        }
    },
    {
        "width": 80,
        "name": "busiNo",
        "header": {
            "text": "사업자등록번호"
        },
        textFormat: "([0-9]{3})([0-9]{2})([0-9]{5});$1-$2-$3"
    },
    {
        "width": 80,
        "name": "cliTypeNm",
        "header": {
            "text": "광고주유형"
        }
    },
    {
        "width": 60,
        "name": "frstDealDt",
        "header": {
            "text": "거래시작일"
        },
        textFormat: "([0-9]{4})([0-9]{2})([0-9]{2});$1-$2-$3"
    },
    {
        "width": 60,
        "name": "lastDealDt",
        "header": {
            "text": "거래종료일"
        },
        textFormat: "([0-9]{4})([0-9]{2})([0-9]{2});$1-$2-$3"
    }
    , {"visible": false, "name": "dealStsCd"}
    , {"visible": false, "name": "cliTypeCd"}
];

/**
 *
 * User : 이연우
 * Date : 2023.05.08
 * @ file : Components/Common/CpmCommPFindCli.js
 * @ Desc : 광고주 검색 공통 팝업 Component
 * @param {string} cliStr 외부에서 입력한 cliStr 값
 * @param {string} agncyId 외부에서 입력한 agncyId 값
 * @param {boolean} modalIsOpen 모달 렌더링 여부
 * @param {React.SetStateAction | Function} handleModal 모달 상태 제어 함수
 * @param {React.SetStateAction | Function} onChangeParams 외부 컴포넌트 state 세터 함수
 */
const CpmCommPFindCli = ({
                             cliStr,
                             agncyId,
                             modalIsOpen,
                             handleModal,
                             onChangeParams ,
                             cable= ""
                         }) => {
    const extSubmission = useExtSubmission();
    const [rows, setRows] = useState([]); // 그리드 row 값
    const [grid, setGrid] = useState(null); // 그리드

    // form 상태 관리
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            cliStr: cliStr || "", // 광고주
            agncyId: agncyId || "", // 광고회사
            chkAll: agncyId ? true : false, // 전체
            chkAf: false, // 추후지정
            uniInclude: false, // 공동광고주 포함
            amtExist: false, // 청약 광고주만 조회
            pastChk: false, // 대행만료 포함
            noDealYn: false, // 거래불가 포함
            cable : cable
        },
         // validation 체크
        validationSchema: Yup.object({
            // chkAll 또는 chkAf 가 true면 cliStr 빈값 검사 안함
            cliStr: Yup.string()
            .when(['chkAll', 'chkAf'], {
                is: (chkAll, chkAf) => chkAll || chkAf,
                then: (schema) => schema,
                otherwise: (schema) => schema.required(),
            })
        }),
        // 검색 버튼 클릭시 작동
        onSubmit: (values) => {
            getRows({
                // ...values
                agncyId: values.agncyId,
                cliStr: values.cliStr,
                chkAll: values.chkAll ? 'Y' : null,
                chkAf: values.chkAf ? 'Y' : null,
                uniInclude: values.uniInclude ? 'Y' : null,
                amtExist: values.amtExist ? 'Y' : null,
                pastChk: values.pastChk ? 'Y' : null,
                noDealYn: values.noDealYn ? 'Y' : null,
                cable : cable
            })
        },
    });

// 초기 시작
    const onLoad = () => {
        try {
            var options = {};
            options.scrnPgmId = 'CpmCommPFindCli';
            options.menuId = '';
            options.columns = columns;
            options.groupingFlag = false;
            options.filterFlag = false;
            options.footerFlag = false;
            options.buttonFlag = false;
            const grid_cli = rg2Comm.setGridInit("grid_cli", options);

            grid_cli.onCellDblClicked = function (grid, clickData) {
                var voJson = grid.getValuesByRow(clickData.dataRow);
                if (voJson.cliId){
                    onChangeParams(voJson);
                    handleModal(false);
                }
            }

            setGrid(grid_cli);
        } catch (e) {
            console.log(e);
        }
    }

    // 확인 버튼 클릭 시 
    function onClick_BtnSelect() {
        var _row = grid.getCurrent().dataRow;
        var voJson = grid.getValuesByRow(_row);
        voJson.isProc = "Y";
        if (_row > -1) {
            onChangeParams(voJson);
        }
        handleModal(false);
    }


    // 광고주 상세 리스트 불러오기 (조회)
    const getRows = async (param) => {
        
        if(cable === "Y") param.cable = "Y";
        await extSubmission(
            "/cpm/com/commCli/subList.do",
            param ,
            (e, data) => {
                if (data.listMain.length < 1) {
                    alert("조회된 결과가 없습니다.");
                    setRows([]);
                    return false;
                }
                setRows(data.listMain);
                grid.setJSON(data.listMain);
            }
        );
    }

    useDidMountEffect(() => {
        // 광고회사가 입력되어 있을때 팝업을 열면 전체 목록 조회
        if (formik.values.cliStr || formik.values.chkAll) {
            formik.submitForm(formik.values);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid])

    useEffect(() => {
        // 모달이 닫히면 상태값, 그리드 초기화 
        if (!modalIsOpen || !formik.values.cliStr) {
            setRows([]);
            formik.resetForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalIsOpen])

    useDidMountEffect(() => {
        // 전체 체크 시 광고주 목록 조회
        if (formik.values.chkAll) {
            formik.setValues({...formik.values, cliStr: ''})
        }
    }, [formik.values.chkAll])

    const realgridProps = {
        title: '광고주 목록',
        onLoad, 
        id: 'grid_cli',
        minHeight : "200px" ,
        minWidth : "400px"        
    };

    return (
        <>
            <Modal
                size='lg'
                isOpen={modalIsOpen}
                backdrop={'static'}
                id="staticBackdrop"
                centered
                toggle={() => {
                    handleModal();
                }}
            >
                <ModalHeader className="modal-title" id="commPFindAgncy-title" toggle={handleModal}>
                    광고주 검색(commPFindCli)
                </ModalHeader>

                <ModalBody className="p-3">
                    <FormikProvider value={formik}>
                        <Form
                            className='d-flex flex-wrap align-items-center bg-light clearfix ps-2 pt-2 pb-2 mb-2 gap-2 position-relative'
                            style={{paddingRight: 50}}
                            onSubmit={(e) => {
                                e.preventDefault();
                                formik.handleSubmit();
                                return false;
                            }}
                            autoComplete="off">
                            <div className="d-flex align-items-center gap-2">
                                <Label className='text-nowrap m-0'>
                                    광고주
                                </Label>
                                <Input
                                    className='form-control-sm form-control'
                                    type="text"
                                    name="cliStr"
                                    id="cliStr"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.cliStr || ""}
                                    invalid={
                                        (formik.touched.cliStr &&
                                            formik.errors.cliStr)
                                            ? true
                                            : false
                                    }
                                    disabled={formik.values.chkAf || formik.values.chkAll}/>
                            </div>

                            {checkboxList.map((checkboxs, idx) => (
                                <div className='d-flex gap-2 flex-wrap' key={`CHECKBOXS_${idx}`}>
                                    {checkboxs.map((checkbox) => (
                                        <div className="form-check" key={`CHECKBOX_${checkbox.value}`}>
                                            <Field
                                                name={checkbox.value}
                                                id={checkbox.value}
                                                className="form-check-input"
                                                type="checkbox"
                                                disabled={checkbox.disabled ?
                                                    checkbox.disabled.reduce((acc, cur) => {
                                                        return acc && formik.values[cur]
                                                    }, true)
                                                    : false}
                                            />
                                            <Label className="form-check-label" htmlFor={checkbox.value}>
                                                {checkbox.label}
                                            </Label>
                                        </div>
                                    ))}
                                </div>
                            ))}
                            <Button type='submit' color='danger' size='sm'
                                    className='position-absolute end-0 bottom-0 m-2'>
                                검색
                            </Button>
                        </Form>
                    </FormikProvider>

                    <div className='d-flex justify-content-between'>
                        <p className="text-muted m-0"> 검색내역 </p>
                        <p className="text-muted m-0"> 총 <strong>{rows?.length || ''}</strong> 건 </p>
                    </div>
                    <RealGrid {...realgridProps} />

                    <div className="hstack gap-2 justify-content-center pt-3">
                        <Button color="dark" onClick={onClick_BtnSelect}>
                            확인
                        </Button>
                        <Button color="primary" onClick={() => handleModal(false)}>
                            취소
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}

export default CpmCommPFindCli;
